import { tWithKeyAttr as t } from "../../i18nHelper";
import React from "react";
import ActionButtonTooltip from "../ActionButtonTooltip/actionButtonTooltip";
import ListPagination from "../listPagination/listPagination";
import styles from "../../pages/treatmentRooms/treatmentRooms.module.css";
import { ITreatmentGroup } from "../../services/types/utils.types";

type Limits = { start: number; end: number };

interface TreatmentGroupsListProps {
  groups: ITreatmentGroup[];
  total: number;
  limits: Limits;
  setLimits: React.Dispatch<React.SetStateAction<Limits>>;
  onEdit: (group: ITreatmentGroup) => void;
  onDeleteClick: (group: ITreatmentGroup) => void;
  onOpenTreatmentPlan: (group: ITreatmentGroup) => void;
}

function TreatmentGroupsList({
  groups,
  total,
  limits,
  setLimits,
  onEdit,
  onDeleteClick,
  onOpenTreatmentPlan,
}: TreatmentGroupsListProps) {
  return (
    <article className={`section ${styles.section}`}>
      <h3 className="sectionTitle">{t('TREATMENT_GROUPS')}</h3>
      <>
        <ul className={`list`}>
          <li
            className={`listRow listRow_header ${styles.listRow} ${styles.listRow_header}`}
          >
            <p className={`listCell`}>{t("GROUP_ID")}</p>
            <p className={`listCell`}>{t("GROUP_NAME")}</p>
            <p className={`listCell`}>{t("MAX_PARTICIPANTS")}</p>
            <p className={`listCell`}>{t("SUITABLE_FOR_TREATMENT_TYPE")}</p>
            <p className={`listCell`}>{t("COLUMN_STATUS")}</p>
            <p className={`listCell`}>{t("COLUMN_OPTIONS")}</p>
          </li>

          {groups.map((group, i) => {
            const index = i + (limits.start - 1);
            return (
              <li
                key={group.id}
                className={`listRow ${styles.listRow} ${
                  (index + limits.start - 1) % 2 === 0 && "listRow_colored"
                }`}
              >
                <p className={`listCell`}>{group.id}</p>
                <p className={`listCell`}>{group.groupName}</p>
                <p className={`listCell`}>
                  {group.maxParticipants === undefined || group.maxParticipants === null ? t("UNLIMITED") : group.maxParticipants}
                </p>
                <div className={`listCell`}>
                  {group.therapyTypeName}
                </div>
                <div className={`listCell`}>
                  {group.statusName ?? (group.statusId === 1 ? t("STATUS_ACTIVE") : t("STATUS_INACTIVE"))}
                </div>
                <div className={`listCell`}>
                  <ActionButtonTooltip
                    className="btn btn_type_edit"
                    onClick={() => onEdit(group)}
                    text={t('EDIT_TREATMENT_GROUP')}
                    tooltipPosition="center"
                  />
                  <ActionButtonTooltip
                    className="btn btn_type_treatmentPlan"
                    onClick={() => onOpenTreatmentPlan(group)}
                    text={t('TREATMENT_PLANS')}
                    tooltipPosition="center"
                  />
                  <ActionButtonTooltip
                    className={`btn btn_type_delete ${
                      group.statusId === 0 ? "button_disabled" : ""
                    }`}
                    disabled={group.statusId === 0}
                    onClick={() => {
                      if (group.statusId === 0) return;
                      onDeleteClick(group);
                    }}
                    text={t('DELETE_TREATMENT_GROUP')}
                    tooltipPosition="center"
                  />
                </div>
              </li>
            );
          })}
        </ul>
        <ListPagination
          total={total}
          limits={limits}
          setLimits={setLimits}
          step={7}
        />
      </>
    </article>
  );
}

export default TreatmentGroupsList;
